// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

import { AccountInvoice } from './../../model/account-invoice';

export const LOAD_ACCOUNT_INVOICES = '[Account Invoices] Load Account Invoices';
export const LOAD_ACCOUNT_INVOICES_SUCCESS =
  '[Account Invoices] Load Account Invoices Success';
export const LOAD_ACCOUNT_INVOICES_FAIL =
  '[Account Invoices] Load Account Invoices Failed';

export class LoadAccountInvoices implements Action {
  public readonly type: string = LOAD_ACCOUNT_INVOICES;

  constructor(public payload: any = null) {}
}

export class LoadAccountInvoicesSuccess implements Action {
  public readonly type: string = LOAD_ACCOUNT_INVOICES_SUCCESS;

  constructor(public payload: Array<AccountInvoice>) {}
}

export class LoadAccountInvoicesFail implements Action {
  public readonly type: string = LOAD_ACCOUNT_INVOICES_FAIL;

  constructor(public payload: any) {}
}

export type AccountInvoicesActions =
  | LoadAccountInvoices
  | LoadAccountInvoicesFail
  | LoadAccountInvoicesSuccess;
